<section class="card">

  <div class="card-header">
    <span class="cat__core__title">
      <strong>Questionnaire Review</strong>
    </span>
    <div class="card-block">
      <div class="table-responsive table-bordered margin-bottom-50">
        <table class="table table-hover compact cell-border nowrap table-striped" style="width: 50%">
          <thead>
            <th style="width: 20px">Score</th>
            <th style="width: 20px">Particular</th>
          </thead>
          <tbody>
            <!-- <tr *ngFor="let scoreParticulars of scoreParticular"> -->
            <tr>
              <td style="width: 20px">Probablity &nbsp; (times) : </td>
              <td style="width: 20px"> 1- 10</td>
            </tr>
            <tr>
              <td style="width: 20px">Impact &nbsp; (percentage) : </td>
              <td style="width: 20px"> 1 - 100</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>


  <div class="card-block watermark">
    <form [formGroup]="reviewForm" novalidate>
      <div class="row">
        <div class="col-lg-2 col-sm-2" style="border-right: 1px solid lightgray">
          <div class="p-3" style="text-align: center" *ngFor="
              let evaluationCriteriaDetail of evaluationCriteriaDetails;
              let count = index;
              let last = last
            ">
            <span class="btn btn-squared btn-sm btn-primary" id="{{ count }}"
              style="cursor: pointer; width: 100%; white-space: normal" (click)="
                questionListAgainstCriteriaList(
                  evaluationCriteriaDetail.EvaluationCriteriaID._id,
                  last,
                  count,
                  $event
                )
              ">{{ evaluationCriteriaDetail.EvaluationCriteriaID.EvaluationCriteria }}</span>
          </div>
        </div>
        <div class="col-lg-10 col-sm-10">
          <div *ngFor="let criterialist of criteria; let count = index; let last1 = last">
            <!-- <pagination-controls
              class="row float-right"
              (pageChange)="p = $event"
              (pageBoundsCorrection)="p = $event"
            ></pagination-controls> -->
            <br />
            <!-- <div *ngFor="
                let criterias of criterialist.EvaluationQuestion
                  | paginate: { itemsPerPage: 5, currentPage: p }
                  ;
                let count1 = index
              "> -->
            <div *ngFor="let criterias of criterialist.EvaluationQuestion; let count1 = index"
              class="criteria-card mb-3 p-3">
              <div class="d-flex align-items-center">
                <button (click)="toggledept(criterias.EvaluationQuestionId)"
                  class="btn btn-outline-primary btn-sm mr-2 criteria-toggle">
                  <i class="fa"
                    [ngClass]="qId === criterias.EvaluationQuestionId ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                </button>
                <span class="dept-label badge badge-info text-uppercase px-3 py-2">
                  {{ criterias.RiskDepartmentId.RiskDepartment }}
                </span>
                <span class="ml-auto text-muted font-weight-bold" style="font-size: 1.1em;">
                  #{{ 5 * (p - 1) + (count1 + 1) }}
                </span>
              </div>

              <div *ngIf="qId === criterias.EvaluationQuestionId" class="mt-3 pl-4">
                <div class="question-title font-weight-bold mb-2">
                  {{ criterias.EvaluationQuestionId.QuestionText }}
                </div>

                <div class="row mb-2" style="font-size:0.98em;">
                  <div class="col-md-8">
                    <div class="d-flex flex-column">
                      <div class="d-flex criteria-table-row font-weight-bold mb-1">
                        <span class="font-weight-bold mb-2" style="min-width: 65px;"></span>
                        <span class="criteria-table-cell">Trivial</span>
                        <span class="criteria-table-cell">Low</span>
                        <span class="criteria-table-cell">Medium</span>
                        <span class="criteria-table-cell">High</span>
                        <span class="criteria-table-cell">Critical</span>
                      </div>
                      <div class="d-flex criteria-table-row mb-1">
                        <span class="font-weight-bold mb-2" style="min-width: 65px;">Impact:</span>
                        <span class="criteria-table-cell criteria-impact-value">{{criterias.TrivialImpact}}%</span>
                        <span class="criteria-table-cell criteria-impact-value">{{criterias.LowImpact}}%</span>
                        <span class="criteria-table-cell criteria-impact-value">{{criterias.MediumImpact}}%</span>
                        <span class="criteria-table-cell criteria-impact-value">{{criterias.HighImpact}}%</span>
                        <span class="criteria-table-cell criteria-impact-value">{{criterias.CriticalImpact}}%</span>
                      </div>
                      <div class="d-flex criteria-table-row mb-1">
                        <span class="font-weight-bold mb-2" style="min-width: 65px;">Probablity:</span>
                        <span class="criteria-table-cell criteria-prob-value">{{criterias.TrivialProbability}}</span>
                        <span class="criteria-table-cell criteria-prob-value">{{criterias.LowProbability}}</span>
                        <span class="criteria-table-cell criteria-prob-value">{{criterias.MediumProbability}}</span>
                        <span class="criteria-table-cell criteria-prob-value">{{criterias.HighProbability}}</span>
                        <span class="criteria-table-cell criteria-prob-value">{{criterias.CriticalProbability}}</span>
                      </div>
                    </div>
                    <div class="d-flex criteria-table-row mb-1">
                      <span class="font-weight-bold mb-2">Risk Owner:</span>
                      <span class="criteria-table-cell criteria-prob-value">{{ criterias.RiskOwnerName }}</span>
                      <span class="criteria-table-cell criteria-prob-value"></span>
                      <span class="criteria-table-cell criteria-prob-value"></span>
                      <span class="criteria-table-cell criteria-prob-value"></span>
                      <span class="criteria-table-cell criteria-prob-value"></span>
                    </div>
                  </div>
                </div>
                <div class="form-group mt-3">
                  <label [for]="'comment' + count1" class="font-italic">Comment:</label>
                  <textarea class="form-control" rows="2" [readonly]="!showAcceptButton"
                    id="{{ 'comment' + criterias.EvaluationQuestionId._id }}"
                    [formControl]="reviewForm.controls[criterias.EvaluationQuestionId._id]"
                    (change)="commentChangeEvent($event, criterias.EvaluationQuestionId._id)"></textarea>
                </div>
              </div>

            </div>


            <!-- <pagination-template class="float-right" *ngIf="islastCriteria" #p1="paginationApi"
              (pageChange)="pageChange.emit($event)">
              <div class="pagination-next" [class.disabled]="p1.isLastPage()">
                <a *ngIf="p1.isLastPage() && showAcceptButton" (click)="p1.next()">
                  <button [disabled]="disableSavebutton" [appHasPermission]="{
                      Url: '/api/v1/secure/boardEvaluationFormReview/addEvaluationFormReview',
                      method: 'get',
                      menu: 'EvaluationType'
                    }" class="btn btn-squared btn-sm btn-primary" style="cursor: pointer"
                    (click)="questionWithComments('Approve')">
                    Accept
                  </button>
                  <button [disabled]="disableSavebutton" [appHasPermission]="{
                      Url: '/api/v1/secure/boardEvaluationFormReview/addEvaluationFormReview',
                      method: 'get',
                      menu: 'EvaluationType'
                    }" class="btn btn-squared btn-sm btn-primary" style="cursor: pointer"
                    (click)="questionWithComments('Reject')">
                    Reject
                  </button>
                </a>
              </div>
            </pagination-template> -->


            <div class="float-right" *ngIf="islastCriteria" (pageChange)="pageChange.emit($event)">
              <div class="pagination-next">
                <a *ngIf="showAcceptButton" (click)="p1.next()">
                  <button [disabled]="disableSavebutton" [appHasPermission]="{
                    Url: '/api/v1/secure/boardEvaluationFormReview/addEvaluationFormReview',
                    method: 'get',
                    menu: 'EvaluationType'
                  }" class="btn btn-squared btn-sm btn-primary" style="cursor: pointer"
                    (click)="questionWithComments('Approve')">
                    Accept
                  </button>
                  <button [disabled]="disableSavebutton" [appHasPermission]="{
                    Url: '/api/v1/secure/boardEvaluationFormReview/addEvaluationFormReview',
                    method: 'get',
                    menu: 'EvaluationType'
                  }" class="btn btn-squared btn-sm btn-primary" style="cursor: pointer"
                    (click)="questionWithComments('Reject')">
                    Reject
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>